import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {
  transform(records: Array<any>, propName: string): any {
    return records.sort(function (a, b) {
      return a[propName].localeCompare(b[propName]);
    });
  }
}
